document.addEventListener('DOMContentLoaded', function() {
  var marquees = document.querySelectorAll('.js-aw-marquee');

  marquees.forEach(function(marquee) {
    marquee.addEventListener('touchstart', function() {
      marquee.classList.add('is-paused');
    }, { passive: true });

    marquee.addEventListener('touchend', function() {
      marquee.classList.remove('is-paused');
    });

    marquee.addEventListener('touchcancel', function() {
      marquee.classList.remove('is-paused');
    });
  });
});
